// One home screen per role. This is the single place that decides what the default view ("dashboard") shows
// and what its heading says, so the shell prints exactly one heading and screens never repeat it.
// A missing or unknown role falls back to the shared Today screen.
import type { AppRole } from './permissions.ts';

export type HomeKind = 'today' | 'controlTower' | 'executiveBrief' | 'projectCockpit' | 'myDay' | 'programBoard' | 'workspaceHealth';

export interface RoleHome {
  kind: HomeKind;
  /** Small label above the heading. */
  label: string;
  /** The question the home screen answers; rendered once, by the shell. */
  question: string;
}

const TODAY: RoleHome = { kind: 'today', label: 'Today', question: 'What needs my attention today?' };

const COCKPIT: RoleHome = { kind: 'projectCockpit', label: 'Project Cockpit', question: 'What is blocking my projects?' };

const ROLE_HOME: Partial<Record<AppRole, RoleHome>> = {
  pmo: { kind: 'controlTower', label: 'PMO Control Tower', question: 'What needs PMO attention?' },
  executive: { kind: 'executiveBrief', label: 'Executive Brief', question: 'What needs my decision?' },
  project_manager: COCKPIT,
  senior_project_manager: COCKPIT,
  program_manager: { kind: 'programBoard', label: 'Program Board', question: 'Where are my programmes at risk?' },
  user: { kind: 'myDay', label: 'My Day', question: 'What do I need to do today?' },
  admin: { kind: 'controlCenter', label: 'Control Center', question: 'How is Masira configured and governed?' },
};

export function homeFor(role: AppRole | null | undefined): RoleHome {
  return (role && ROLE_HOME[role]) || TODAY;
}
